import React from 'react';

import { connect } from 'react-redux';
import * as organizationConstants from '../../constants/organizations';
import * as organizationSettingsSelectors from '../../selectors/organizationSettingsSelectors';
import GaSettings from '../../components/settings/GaSettings';

class OrganizationGaSettings extends React.Component {
    componentDidMount() {
        const { fetchGaSettings, ga } = this.props;
        if (!ga) {
            fetchGaSettings();
        }
    }

    render() {
        const { ga, fetchGaSettings, ...rest } = this.props;
        if (!ga) {
            return null;
        }

        return <GaSettings {...ga} {...rest} />;
    }
}

const mapStateToProps = state => {
    return {
        ga: organizationSettingsSelectors.getGa(state),
    };
};

const mapDispatchToProps = dispatch => ({
    onGaChange: ga => {
        dispatch({
            type: organizationConstants.CHANGE_ORGANIZATION_SETTINGS_GA,
            payload: { ga },
        });
    },
    fetchGaSettings: () => {
        dispatch({
            type: organizationConstants.FETCH_ORGANIZATION_GA_SETTINGS_REQUEST,
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrganizationGaSettings);



// WEBPACK FOOTER //
// ./src/containers/organizationSettings/OrganizationGaSettings.js